import * as React from "react";

declare const window: any;

export default function HorizontalBarContainer({
  setSubMenuSelected,
  setSubMenuSelectedTemp,
  colors,
  menus,
  builderLogo,
  projectLogo,
  theme,
  active,
  setMenuSelected,
  menuSelected,
  setFrame,
  setGaleriaSelected,
  introView,
  isHidden,
  setIsHidden,
  setIsSideBarVertical,
  isLoading
}: any) {
  const [animationIntro, setAnimationIntro] = React.useState(false);
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [startXOther, setStartXOther]: any = React.useState(0);

  React.useEffect(() => {
    if (!introView) {
      let hrr: any = document.querySelector(".horizontal-bar-container");
      hrr.style.bottom = "-7.625rem";
      setIsHidden(true);
      setTimeout(() => {
        hrr.style.removeProperty("bottom");
        setAnimationIntro(true);
        setIsHidden(false);
      }, 500);
    }
  }, [introView]);

  const handleAddDown = (val) => {
    var sidebarOriginal: any = document.querySelector(
      ".horizontal-bar-container"
    );
    if (val) {
      sidebarOriginal.classList.remove("down");
      sidebarOriginal.classList.add("animation");
    } else {
      sidebarOriginal.classList.remove("animation");
      sidebarOriginal.classList.add("down");
    }
    var sidebar: any = document.querySelector(".horizontal-bar-container.down");
    var sidebarInternal = document.querySelector(
      ".horizontal-bar-internal-container"
    );

    if (sidebar) {
      sidebar.style.bottom = "-5.3125rem";
    } else {
      sidebarOriginal.style.removeProperty("bottom");
    }
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  return (
    <div
      className={`horizontal-bar-container ${isHidden || isLoading ? "down" : "animation"} ${
        animationIntro ? active + " animation" : active
      }`}
    >
      <div
        className={`horizontal-bar-toggle ${theme} ${menuSelected}`}
        onClick={() => {
          setIsHidden(
            !isHidden
          ); /* , !isHidden ? setIsSideBarVertical(false) : null */
        }}
      >
        <i
          style={{ transform: isHidden ? "rotate(0deg)" : "rotate(180deg)" }}
          className={`fa-solid fa-chevron-up`}
        ></i>
      </div>
      <div
        className={`horizontal-bar-internal-container ${theme} ${menuSelected}`}
      >
        <div
          className={`horizontal-bar-toggle-internal ${theme}`}
          onClick={() => setIsHidden(!isHidden)}
        ></div>
        <div className="horizontal-bar-internal-container-final">
          <div className="horizontal-bar-logos">
            <div>
              <img
                src={`${window.hybrid ? "./" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/" }${builderLogo}`}
                alt=""
              />
              <img
                src={`${window.hybrid ? "./" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/" }${projectLogo}`}
                alt=""
              />
            </div>
          </div>
          {menus.map((menu: any, index: number) => (
            <div
              className="horizontal-bar-menu"
              key={`menu-${index}`}
              style={
                menu.name === menuSelected
                  ? { backgroundColor: colors?.main_buttons, color: "#fff" }
                  : {}
              }
              onMouseOver={(e) => {
                if (menu.name !== menuSelected) {
                  e.currentTarget.style.backgroundColor = darkenColor(
                    colors?.main_buttons,
                    0
                  );
                }
              }}
              onMouseOut={(e) => {
                if (menu.name !== menuSelected) {
                  e.currentTarget.style.backgroundColor = "";
                }
              }}
              onClick={() => {
                setMenuSelected(menu.name === menuSelected ? "" : menu.name),
                  //menuSelected === "Urbanismo" ? setFrame(1) : null,
                  setSubMenuSelected("");
                  setSubMenuSelectedTemp("")
              }}
            >
              <img
                src={menu.icono}
                alt=""
                style={
                  menu.name === menuSelected
                    ? { filter: "invert(1) brightness(100%)" }
                    : {}
                }
              />
              <span>{menu.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
